import React from 'react'
import './Testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'
import {Pagination,Navigation} from 'swiper'
import {Swiper,SwiperSlide} from 'swiper/react'
import 'swiper/css';
import 'swiper/css/pagination'
import 'swiper/css/navigation'
const data=[
  {
    avatar:AVTR1,
    name:'Tina Snow',
    review:'Honestly I recommend Emma for all cybersecurity advice he\'s really a prodigy'
  },
  {
    avatar:AVTR2,
    name:'George Snow',
    review:'The tenacity of this young lad never ceases to amaze me. From a self to programmer to a great web developer'
  },
  {
    avatar:AVTR3,
    name:'Tina Sterling',
    review:'Such a young talent keep it up'
  },
  {
    avatar:AVTR4,
    name:'Micheal Snow',
    review:'Worked on few projects so far. However these projects are great generally'
  },
]
const Testimonials = () => {

  return (
    <section id='testimonial'>
      <h5>Review From Clients</h5>
      <h2>Testimonials</h2>
      <Swiper className="container testimonials__container"
       modules={[Pagination,Navigation]}
       spaceBetween={40}
       slidesPerView={1}
       
       pagination={{clickable:true}}
       navigation
       >
        
       {
        data.map(({avatar,name,review},key)=>{

          return(
            <SwiperSlide className="testimonial" key={key}>
            <div className="client__avatar">
            <img src={avatar} alt="Avatar one" />
            </div>
            <h5 className='client__name'>{name}</h5>
            <small className='client__review'>
              {review}
            </small>
          </SwiperSlide>
          )
        })
       }
      </Swiper>
     
    </section>
  )
}

export default Testimonials